/** API route map: URLS.Controller.ClientBenefitsEnrollment */
export const ClientBenefitsEnrollment = {
      Name: 'ClientBenefitsEnrollment/',
      AddDependent: 'add-benefit-enrollment-dependents',
      AddDependentEmployee: 'add-benefit-enrollment-dependents-employee',
      AddBenefitEnrollmentMain: 'add-benefit-enrollment-main',
      SignBenefitEnrollmentMain: 'sign-benefit-enrollment-main',
      UpdateBenefitEnrollmentMain: 'update-benefit-enrollment-main',
      GetAllDependents: 'get-benefit-enrollment-dependents',
      GetAllDependentsEmployee: 'get-benefit-enrollment-dependents-employee',
      DeleteDependent: 'delete-dependent',
      DeleteDependentEmployee: 'delete-dependent-employee',
      UpdateDependent: 'update-dependent',
      UpdateDependentEmployee: 'update-dependent-employee',
      GetAllDependentsForEnrollment: 'get-benefit-dependents-for-enrollment',
      GetAllDependentsForEnrollmentEmployee: 'get-benefit-dependents-for-enrollment-employee',
      GetBenefitEnrollmentMain: 'get-all-enrollment-main-details',
      GetEmployeeAndEmployerDetail: 'get-benefit-enrollment-for-pdf',
      GetEmployeeAndEmployerDetailEmployee: 'get-benefit-enrollment-for-pdf-employee',
      GetBenefitEnrollmentMainEmployee: 'get-all-enrollment-main-details-employee',
      GetEnrollPlans: 'get-enroll-plans',
      AddBenefitEnrollmentCoverage: 'add-benefit-enrollment-coverage',
      AddBenefitEnrollmentCoverageEmployee: 'add-benefit-enrollment-coverage-employee',
      GetAllBenefitEnrollmentCoverage: 'get-all-benefit-enrollment-coverage',
      GetAllBenefitEnrollmentCoverageEmployee: 'get-all-benefit-enrollment-coverage-employee',
      DeleteBenefitEnrollmentCoverage: 'delete-benefit-enrollment-coverage',
      DeleteBenefitEnrollmentCoverageEmployee: 'delete-benefit-enrollment-coverage-employee',
      UpdateBenefitEnrollmentCoverage: 'update-benefit-enrollment-coverage',
      UpdateBenefitEnrollmentCoverageEmployee: 'update-benefit-enrollment-coverage-employee',
      GetClientDepend: 'get-client-depend',
      AddMedicare: 'add-benefit-enrollment-medicare',
      AddMedicareEmployee: 'add-benefit-enrollment-medicare-employee',
      GetAllMedicare: 'get-benefit-enrollment-medicare',
      GetAllMedicareEmployee: 'get-benefit-enrollment-medicare-employee',
      DeleteMedicare: 'delete-medicare',
      DeleteMedicareEmployee: 'delete-medicare-employee',
      UpdateMedicare: 'update-medicare',
      UpdateMedicareEmployee: 'update-medicare-employee',
      AddBeneficiary: 'add-benefit-enrollment-beneficiary',
      GetAllBeneficiary: 'get-benefit-enrollment-beneficiary',
      DeleteBeneficiary: 'delete-beneficiary',
      UpdateBeneficiary: 'update-beneficiary',
      AddBeneficiaryEmployee: 'add-benefit-enrollment-beneficiary-employee',
      GetAllBeneficiaryEmployee: 'get-benefit-enrollment-beneficiary-employee',
      DeleteBeneficiaryEmployee: 'delete-beneficiary-employee',
      UpdateBeneficiaryEmployee: 'update-beneficiary-employee',
      GetEmployeeAdjustmentPlans: 'get-employee-adjustment-plans',
      GetEmployeeBenefitHistory: 'get-employee-benefit-history',
      GetClientEmployeeBenefitEnrollment: 'get-client-employee-benefit-enrollment',
      GetBenefitPlan: 'get-benefit-plan',
      GetClientBenefitPlans: 'get-all-plane-names-by-client-id',
      SaveClientClonePlans: 'clone-benefit-plans-for-client',
};
